import React, {Component} from "react";

const randomData = ["a","b",];

//局部loading   小loading
class PartLoading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //时间初始化
            t: 0,

            //loading 宽高
            width: props.width || 80,
            height: props.height || 80,

            //圆半径
            r: 5,
            //速度
            speed: 5,
            //靠近度
            approximate: 3,

            timestampId: "",
        };
    };

    componentWillMount() {


        this.setState({
            timestampId: new Date().getTime(),
        })
    }

    componentDidMount() {
        this.initCanvas();
    }


    initCanvas() {
        let _this = this;
        let height = _this.state.height;
        let width = _this.state.width;

        var canvas = document.getElementById(_this.state.timestampId);
        var context = canvas.getContext('2d');
        canvas.height = height;
        canvas.width = width;
        context.fillStyle = '#ff6468';
        context.beginPath();


        context.arc(width / 2, height / 2, _this.state.r, 0, 2 * Math.PI, true);

        context.closePath();
        context.fill();
        //设置定时器，生成动画
        setInterval(function () {
            _this.run(context);
        }, 5);
// var speed=0;
    }

    run(cxt) {
        let t = this.state.t;
        let height = this.state.height;
        let width = this.state.width;
        let r = this.state.r;
        let speed = this.state.speed;
        let approximate = this.state.approximate;

        t = t + 0.005;
        this.setState({
            t: t,
        });
//画红色圆
        var startPoint = height / approximate * Math.sin(t * speed) + width / 2;
        var r1 = r * Math.cos(t * speed) + r * 1.5;
        cxt.clearRect(0, 0, width, height);
        //cxt.top+=speed;
        // startPoint+=speed;
        cxt.beginPath();
        cxt.fillStyle = '#ff6468';
        cxt.arc(startPoint, height / 2, r1, 0, 2 * Math.PI, true);
        cxt.closePath();
        cxt.fill();
//画蓝色圆
        var startPoint2 = height / approximate * Math.sin(t * speed + Math.PI) + width / 2;
        var r2 = r * Math.cos(t * speed + Math.PI) + r * 1.5;
        cxt.beginPath();
        cxt.fillStyle = '#4aa5fe';
        cxt.arc(startPoint2, height / 2, r2, 0, 2 * Math.PI, true);
        cxt.closePath();
        cxt.fill();
    }

    render() {
        return (
            <div>
                <div style={Object.assign({
                    display: "inline-block",
                }, this.props.style)}>
                    <canvas id={this.state.timestampId} width="200" height="100">
                        您的浏览器不支持 HTML5 canvas 标签。
                    </canvas>
                </div>
            </div>
        )
    }
}


export default PartLoading;
